import React from 'react';
import { Link } from 'react-router-dom';
import { Star, ArrowRight } from 'lucide-react';
import { isBrandActive } from '../../utils/vendorBranding';

const ServiceCard = ({ service, vendorRating, category, brand }) => {
  const imageUrl = service.image_url || service.vendor_profile?.image_url || service.vendor_profile?.user?.profile_image_url;
  const brandActive = isBrandActive(brand);
  const badgeStyle = brandActive ? { backgroundColor: brand.primary_color } : undefined;

  return (
    <Link
      to={`/services/${service.id}`}
      className={`group block ${brandActive ? '' : ''}`}
    >
      <div
        className={`flex h-full flex-col overflow-hidden rounded-m-card border border-m-border-light bg-m-surface transition-colors ${
          brandActive ? '' : 'group-hover:border-m-ink/30'
        }`}
        style={brandActive ? { '--tw-ring-color': brand.primary_color } : undefined}
        onMouseEnter={(e) => {
          if (brandActive) e.currentTarget.style.borderColor = brand.primary_color;
        }}
        onMouseLeave={(e) => {
          if (brandActive) e.currentTarget.style.borderColor = '';
        }}
      >
        <div
          className={`relative h-36 w-full overflow-hidden sm:h-40 ${brandActive ? '' : 'bg-m-ink'}`}
          style={brandActive ? { backgroundColor: brand.primary_color } : undefined}
        >
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={service.service_name}
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
            />
          ) : (
            <div className="flex h-full w-full items-center justify-center text-2xl text-white/40">
              📷
            </div>
          )}

          {category ? (
            <div
              className={`absolute left-2 top-2 rounded-md px-2 py-0.5 text-[10px] font-medium text-white ${
                brandActive ? '' : 'bg-m-ink/85'
              }`}
              style={badgeStyle}
            >
              {category.category_name}
            </div>
          ) : null}

          {vendorRating ? (
            <div className="absolute right-2 top-2 flex items-center gap-0.5 rounded-md bg-m-surface/95 px-1.5 py-0.5 text-[10px] font-medium text-m-ink">
              <Star className="h-2.5 w-2.5 fill-current" />
              <span>{vendorRating}</span>
            </div>
          ) : null}
        </div>

        <div className="flex flex-1 flex-col p-3 sm:p-3.5">
          <h3 className="mb-1.5 line-clamp-2 text-sm font-semibold tracking-tight text-m-ink sm:text-base">
            {service.service_name}
          </h3>

          <p className="mb-3 line-clamp-2 flex-1 text-xs leading-snug text-m-ink-muted sm:text-sm">
            {service.description || 'Professional service for your special events.'}
          </p>

          <div className="flex items-center justify-between border-t border-m-border-light pt-2.5">
            <div className="flex items-center gap-1.5 text-xs text-m-ink-muted">
              <span className="font-normal">Starting from</span>
            </div>
            
            <div className="flex items-center gap-1 sm:gap-1.5">
              <span className="text-sm font-semibold tracking-tight text-m-ink sm:text-base">
                ${service.base_price || 'Contact'}
              </span>
              <ArrowRight className="h-3.5 w-3.5 shrink-0 text-m-ink-muted transition-transform group-hover:translate-x-0.5 group-hover:text-m-ink" />
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ServiceCard;

